const formatTasks = (baseTasks: any[]) => {
  return baseTasks.map((group: any) => ({
    ...group,
    tasks: group.tasks.map((task: any) => ({
      ...task,
      status: getStatus(task),
    })),
  }));
};

export default formatTasks;

const getStatus = (task: any) => {
  if (!task.dueDate) return "no-date";
  const today = new Date();
  const taskDate = new Date(task.dueDate);

  if (
    today.getDate() === taskDate.getDate() &&
    today.getMonth() === taskDate.getMonth() &&
    today.getFullYear() === taskDate.getFullYear()
  ) {
    return "today";
  } else if (today > taskDate) {
    return "passed";
  } else {
    return "future";
  }
};
